import { allowViewScreenings } from '../../../../backend/features/permissions';
import { AuthError } from '@juvare/platform-app/App';
import { implementTypedPlatformFunction } from '@juvare/platform-sdk-react/backend/features/typed-platform-functions';
import { z } from 'zod';
import { updateJasBoardsVerificationHistory } from '../utils';
export const updateJasBoardsVerificationHistoryFunctionDef = {
    name: 'updateJasBoardsVerificationHistory',
    requestSchema: z.object({
        jasBoardId: z.string().uuid().optional(),
    }),
    responseSchema: z.object({
        data: z.object({
            success: z.boolean(),
        }),
    }),
};
export const updateJasBoardsVerificationHistoryFunctionImpl = implementTypedPlatformFunction(updateJasBoardsVerificationHistoryFunctionDef, (context, params) => {
    if (!allowViewScreenings(context.userState)) {
        throw new AuthError('Unauthorized');
    }
    const jasBoardFilter = (params === null || params === void 0 ? void 0 : params.jasBoardId) ? [{ id: params.jasBoardId, op: '=' }] : undefined;
    const { success } = updateJasBoardsVerificationHistory({ jasBoardFilter, context });
    return { data: { success } };
});
